import generateContext, { createAction } from '..';

interface ITutorialState {
  activeTutorial: string | null;
}

const initialState: ITutorialState = {
  activeTutorial: null,
};

enum TutorialActionTypes {
  StartTutorial = 'START_TUTORIAL',
  StopTutorial = 'STOP_TUTORIAL',
}

const reducer = (
  state: ITutorialState,
  action: { type: TutorialActionTypes; payload?: any }
): ITutorialState => {
  switch (action.type) {
    case TutorialActionTypes.StartTutorial:
      return {
        ...state,
        activeTutorial: action.payload,
      };
    case TutorialActionTypes.StopTutorial:
      return {
        ...state,
        activeTutorial: null,
      };
    default:
      return state;
  }
};

const [TutorialCtxProvider, useTutorialState, useTutorialDispatch] =
  generateContext(reducer, initialState);

const useTutorialActions = () => {
  const dispatch = useTutorialDispatch();

  const startTutorial = (payload: Object) => {
    dispatch(createAction(TutorialActionTypes.StartTutorial, payload));
  };

  const stopTutorial = () => {
    dispatch(createAction(TutorialActionTypes.StopTutorial));
  };

  return {
    startTutorial,
    stopTutorial,
  };
};

export { TutorialCtxProvider, useTutorialActions, useTutorialState };
